import { useEffect, useState } from 'react';

// matches MUI's theme.breakpoints.down('sm')
const MUI_SM_BREAKPOINT = '(max-width: 599.95px)';

export const useIsMobile = () => {
  const getIsMobile = () => {
    if (typeof window === 'undefined') return false;
    return window.matchMedia(MUI_SM_BREAKPOINT).matches;
  };

  const [isMobile, setIsMobile] = useState(getIsMobile);

  useEffect(() => {
    const mediaQuery = window.matchMedia(MUI_SM_BREAKPOINT);

    const handleChange = (event: MediaQueryListEvent) => {
      setIsMobile(event.matches);
    };

    mediaQuery.addEventListener('change', handleChange);

    return () => {
      mediaQuery.removeEventListener('change', handleChange);
    };
  }, []);

  return isMobile;
};
